import { NavigationItem } from 'src/app/core/components/pages-container/interfaces/navigationList.interface';

export const routes: NavigationItem[] = [
  {
    id: 1,
    name: 'Rides',
    iconClass: 'icon-police-car',
    routeUrl: '/rides',
    children: [
      {
        id: 6,
        name: 'Active Rides',
        iconClass: 'icon-compass',
        routeUrl: '/dispatch/monitoring-center/rides',
        children: [],
        permissions: ['ServiceProviderActiveRidesView'],
      },
      {
        id: 7,
        name: 'Ride Simulator',
        iconClass: 'icon-steering-wheel',
        routeUrl: '/rides/ride-simulator',
        children: [],
        permissions: ['ServiceProvidersRideSimulatorView'],
      },
    ],
  },
  {
    id: 2,
    name: 'Accounting',
    iconClass: 'icon-seal-percent',
    routeUrl: '/accounting',
    children: [
      {
        id: 8,
        name: 'My Payouts',
        iconClass: 'icon-hand-coins',
        routeUrl: '/accounting/my-payouts',
        children: [],
        permissions: ['ServiceProviderPayoutsView'],
      },
      {
        id: 9,
        name: 'Drivers Weekly Payouts',
        iconClass: 'icon-wallet',
        routeUrl: '/accounting/drivers-weekly-payouts',
        children: [],
        permissions: ['ServiceProviderDriversWeeklyPayoutsView'],
      },
      {
        id: 10,
        name: 'Drivers Payout Statements',
        iconClass: 'icon-currency-circle-dollar',
        routeUrl: '/accounting/drivers-payout-statements',
        children: [],
        permissions: ['ServiceProviderDriversPayoutStatementsView'],
      },
      {
        id: 11,
        name: 'Payout Dispute',
        iconClass: 'icon-coins',
        routeUrl: '/accounting/payout-dispute',
        children: [],
        permissions: ['ServiceProviderDisputeView'],
      },
    ],
  },
  {
    id: 3,
    name: 'Routing',
    iconClass: 'icon-path',
    routeUrl: '/routing',
    children: [
      {
        id: 12,
        name: 'Ride Blueprint Management',
        iconClass: 'icon-car-profile',
        routeUrl: '/routing/ride-blueprint-management',
        children: [],
        permissions: ['ServiceProviderRideBluePrintView'],
      },
      {
        id: 13,
        name: 'Ride Blueprint Offers',
        iconClass: 'icon-tag',
        routeUrl: '/routing/ride-blueprint-offers',
        children: [],
        permissions: ['ServiceProviderRideBlueprintOffersView'],
      },
    ],
  },
  {
    id: 4,
    name: 'Drivers',
    iconClass: 'icon-users-three',
    routeUrl: '/drivers',
    children: [
      {
        id: 14,
        name: 'Leads',
        iconClass: 'icon-megaphone',
        routeUrl: '/drivers/leads',
        children: [],
        permissions: ['ServiceProviderLeadsView'],
      },
      {
        id: 15,
        name: 'Drivers & Monitors',
        iconClass: 'icon-user',
        routeUrl: '/drivers/drivers-and-monitors',
        children: [],
        permissions: ['ServiceProviderDriversAndMonitorsView'],
      },
      {
        id: 16,
        name: 'Drivers Data Integrity',
        iconClass: 'icon-chart-line',
        routeUrl: '/drivers/drivers-data-integrity',
        children: [],
        permissions: ['ServiceProviderDriversComplianceView'],
      },
    ],
  },
  {
    id: 18,
    name: 'Vehicles & Equipment',
    iconClass: 'icon-wheelchair',
    routeUrl: '/vehicles-equipment',
    children: [
      {
        id: 19,
        name: 'Vehicles',
        iconClass: 'icon-car-profile',
        routeUrl: '/vehicles-equipment/vehicles',
        children: [],
        permissions: ['ServiceProviderVehiclesView'],
      },
      {
        id: 20,
        name: 'Equipment Types',
        iconClass: 'icon-wheelchair',
        routeUrl: '/vehicles-equipment/equipment-types',
        children: [],
        permissions: ['ServiceProviderEquipmentView'],
      },
      {
        id: 21,
        name: 'Equipment Assignments',
        iconClass: 'icon-user-gear',
        routeUrl: '/vehicles-equipment/equipment-assignments',
        children: [],
        permissions: ['ServiceProviderEquipmentAssignmentsView'],
      },
    ],
  },
  {
    id: 5,
    name: 'Reports',
    iconClass: 'icon-files',
    routeUrl: '/reports',
    children: [
      {
        id: 17,
        name: 'Arrival Time Report',
        iconClass: 'icon-clipboard-text',
        routeUrl: '/reports/arrival-time-report',
        children: [],
        permissions: ['ServiceProviderArrivalTimeReportView'],
      },
    ],
  },
];
